<script setup>
const props = defineProps({
    title: {
        type: String,
        default: "Example title",
    },
    count: {
        type: Number,
        default: 0,
    },
    show: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(["section-click"]);
</script>

<template>
    <div class="mt-4">
        <div @click="emit('section-click')" class="d-flex flex-row cursor-pointer">
            <div class="mr-auto title" :class="{'font-weight-bold': props.show}">{{ props.title }}({{ count }})</div>
            <svg v-if="!props.show" width="21" height="21" viewBox="0 0 21 21" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_1315_12579)">
                    <path
                        d="M0.00183105 10.5002C0.00183105 16.299 4.7031 21.0002 10.5018 21.0002C16.3006 21.0002 21.0018 16.299 21.0018 10.5002C21.0018 4.70152 16.3006 0.000244141 10.5018 0.000244141C4.7031 0.000244141 0.00183105 4.70152 0.00183105 10.5002ZM14.777 8.71777C14.8513 8.63961 14.9405 8.57711 15.0392 8.53395C15.138 8.49079 15.2445 8.46784 15.3523 8.46646C15.4601 8.46508 15.567 8.48529 15.6669 8.52591C15.7668 8.56653 15.8575 8.62673 15.9337 8.70296C16.01 8.77919 16.0702 8.86991 16.1108 8.96978C16.1514 9.06964 16.1716 9.17663 16.1702 9.28442C16.1689 9.39222 16.1459 9.49866 16.1027 9.59745C16.0596 9.69624 15.9971 9.78539 15.9189 9.85964L11.0728 14.7058C10.9213 14.8572 10.716 14.9422 10.5018 14.9422C10.2877 14.9422 10.0823 14.8572 9.93089 14.7058L5.08474 9.85964C4.93966 9.70694 4.85998 9.5036 4.86267 9.29299C4.86537 9.08237 4.95023 8.88114 5.09917 8.7322C5.24811 8.58326 5.44934 8.4984 5.65996 8.4957C5.87057 8.493 6.07391 8.57269 6.22661 8.71777L10.5018 12.9925L14.777 8.71777Z"
                        fill="#FFB700"/>
                </g>
                <defs>
                    <clipPath id="clip0_1315_12579">
                        <rect width="21" height="21" fill="white" transform="translate(0 21) rotate(-90)"/>
                    </clipPath>
                </defs>
            </svg>

            <svg v-if="props.show" width="21" height="21" viewBox="0 0 21 21" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_1315_12575)">
                    <path
                        d="M20.9982 10.4996C20.9982 4.70091 16.2969 -0.000366155 10.4982 -0.000366086C4.69944 -0.000366017 -0.001831 4.70091 -0.00183093 10.4996C-0.00183086 16.2984 4.69944 20.9996 10.4982 20.9996C16.2969 20.9996 20.9982 16.2984 20.9982 10.4996ZM6.22295 12.2821C6.1487 12.3603 6.05955 12.4228 5.96076 12.4659C5.86196 12.5091 5.75553 12.532 5.64773 12.5334C5.53994 12.5348 5.43295 12.5146 5.33309 12.474C5.23322 12.4333 5.1425 12.3732 5.06627 12.2969C4.99004 12.2207 4.92984 12.13 4.88922 12.0301C4.8486 11.9302 4.82839 11.8233 4.82977 11.7155C4.83115 11.6077 4.8541 11.5012 4.89726 11.4024C4.94042 11.3036 5.00292 11.2145 5.08108 11.1402L9.92723 6.29408C10.0787 6.14272 10.284 6.0577 10.4982 6.0577C10.7123 6.0577 10.9177 6.14272 11.0691 6.29408L15.9153 11.1402C16.0603 11.2929 16.14 11.4963 16.1373 11.7069C16.1346 11.9175 16.0498 12.1187 15.9008 12.2677C15.7519 12.4166 15.5507 12.5015 15.34 12.5042C15.1294 12.5069 14.9261 12.4272 14.7734 12.2821L10.4982 8.0074L6.22295 12.2821Z"
                        fill="#FFB700"/>
                </g>
                <defs>
                    <clipPath id="clip0_1315_12575">
                        <rect width="21" height="21" fill="white" transform="translate(21) rotate(90)"/>
                    </clipPath>
                </defs>
            </svg>

        </div>
        <div v-show="show">
            <slot></slot>
        </div>
    </div>
</template>

<style scoped>

</style>
